import { render, staticRenderFns } from "./BsaEHeaderUtil.vue?vue&type=template&id=5a7631b0&scoped=true"
import script from "./BsaEHeaderUtil.vue?vue&type=script&lang=js"
export * from "./BsaEHeaderUtil.vue?vue&type=script&lang=js"
import style0 from "./BsaEHeaderUtil.vue?vue&type=style&index=0&id=5a7631b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7631b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a7631b0')) {
      api.createRecord('5a7631b0', component.options)
    } else {
      api.reload('5a7631b0', component.options)
    }
    module.hot.accept("./BsaEHeaderUtil.vue?vue&type=template&id=5a7631b0&scoped=true", function () {
      api.rerender('5a7631b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/bsa/BsaEHeaderUtil.vue"
export default component.exports